<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới tin tức</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="image" label="Ảnh bìa tin tức">
              <el-upload
                class="blogs-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="blogs">
                <i v-else class="el-icon-plus blogs-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh bìa tin tức có dung lượng tối đa tải lên là 2Mb (up load ảnh kích thước 680 * 480 để hiện thị lên site đẹp nhất)
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item prop="category_blog_id" label="Danh mục tin tức" class="form-item">
              <el-select v-model="modelData.category_blog_id" filterable clearable placeholder="Danh mục tin tức" class="input-select">
                <el-option
                  v-for="item in lists.listCategoryBlogs"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="name" label="Tiêu đề tin tức" class="form-item">
              <el-input v-model="modelData.name" class="input-seach"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.description" class="input-seach"></el-input>
            </el-form-item> -->
            <el-form-item prop="description" label="Mô tả ngắn" v-if="canUpdate">
              <tinymce
                id="d2"
                v-model="modelData.description"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '200px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item prop="content" label="Nội dung tin tức" v-if="canUpdate">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', images_upload_handler: handleImageAdded , language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item prop="slug" label="SEO Link" class="form-item">
              <el-input v-model="modelData.slug" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_title" label="SEO Tiêu đề" class="form-item">
              <el-input v-model="modelData.seo_title" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_description" label="SEO Mô tả ngắn" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.seo_description" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_tag" label="SEO từ khóa" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.seo_tag" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'BlogCreate',
  metaInfo () {
    return {
      title: 'Tin tức'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      canUpdate: false,
      modelData: {
        category_blog_id: '',
        name: '',
        description: '',
        image: '',
        image_path: '',
        content: '',
        slug: '',
        seo_title: '',
        seo_description: '',
        seo_tag: '',
        status: true
      },
      lists: {
        listCategoryBlogs: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'blogs/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link unlink image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        title: [
          { required: true, message: 'Vui lòng nhập tiêu đề tin tức' },
          { min: 2, max: 191, message: 'Tiêu đề tin tức có chiều dài từ 2 tới 191 kí tự' }
        ],
        description: [
          { required: true, message: 'Vui lòng nhập mô tả ngắn tin tức' }
        ],
        category_blog_id: [
          { required: true, message: 'Vui lòng nhập danh mục tin tức' }
        ],
        content: [
          { required: true, message: 'Vui lòng nhập nội dung tin tức' }
        ],
        image: [
          { required: true, message: 'Vui lòng upload ảnh bìa của tin tức' }
        ],
        slug: [
          { required: true, message: 'Vui lòng nhập Seo link' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.configUpload()
    this.fetchListCategoryBlogs()

    setTimeout(() => {
      this.canUpdate = true
    }, 500)
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('blogs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'blogs-index', text: 'Tin tức' },
        { name: 'blogs-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    sanitizeTitle: function (title) {
      var slug = ''
      var titleLower = title.toLowerCase()
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      slug = slug.replace(/i|í|ì|ỉ|ị|ĩ/gi, 'i')
      slug = slug.replace(/đ/gi, 'd')
      slug = slug.replace(/y|ý|ỳ|ỹ|ỵ|ỷ/gi, 'y')
      slug = slug.replace(/\s*$/g, '')
      slug = slug.replace(/\s+/g, '-')

      return slug
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'blogs-index'})
    },
    // Fetch dữ liệu về lĩnh vực tin tức
    fetchListCategoryBlogs () {
      axios.get('category-blogs/get-recursive-category-blogs').then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryBlogs = response.data.categories
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('blogs', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm tài khoản thành công',
              type: 'success'
            })
            this.$router.push({name: 'blogs-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh tin tức có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  },
  watch: {
    'modelData.name': function () {
      this.modelData.slug = this.sanitizeTitle(this.modelData.name)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.blogs {
  width: 840px;
  height: 300px;
  display: block;
  object-fit: cover;
}
</style>

<style type="text/css">
.blogs-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.blogs-uploader .el-upload:hover {
  border-color: #409EFF;
}
.blogs-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 840px;
  height: 300px;
  line-height: 300px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/blogs/Create.vue